import React, { useEffect } from "react";
import "./ProfileVerified.css";
import OnboardingHeader from "../../Onboarding/OnboardingHeader";
import Icons from "../../../../../Config/Images";
import { getLoggedInUserDetailsAPI } from "../../../../../Store/Action/UserAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Header from "../../../Layout/Header/Header";
import HeaderBlack from "../../../WelcomeScreen/Common/Header";

const ProfileVerified = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Get the logged-in user details to check their status
  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        const userStatus = result?.data?.[0]?.user_status_name;

        if (userStatus === "rejected") {
          // Redirect to the Profile Not Approved page if status is rejected
          navigate("/profile-not-approved", { replace: true });
        } else if (userStatus === "approved") {
          // Redirect to the Profile Verified page if status is approved
          navigate("/profile-verified", { replace: true });
        }
      })
    );
  }, [dispatch, navigate]);
  // Disable back navigation **only on home page ("/")**
  useEffect(() => {
    const disableBack = () => {
      if (window.location.pathname === "/home") {
        window.history.pushState(null, "", window.location.href);
        window.history.go(1);
      }
    };

    if (window.location.pathname === "/home") {
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", disableBack);
    }

    return () => {
      window.removeEventListener("popstate", disableBack);
    };
  }, []);
  const handleHomeClick = () => {
    navigate("/home", { replace: true });

    setTimeout(() => {
      window.history.pushState(null, "", window.location.href);
    }, 100); // Ensures navigation completes before modifying history
  };

  return (
    <>
      {/* <OnboardingHeader /> */}
      <div style={{ position: "sticky", top: 0 }}>
        <div className="section-1-div">
          <HeaderBlack noLoginBtn={true} />
        </div>
      </div>
      <div
        className="profile-verified"
        style={{
          backgroundImage: `url(${Icons.loginBgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
      >
        <div className="profile-review-card-verified">
          <div className="profile-review-image">
            <img
              src={Icons.profile_verified_image}
              alt="Profile Under Review Image"
            />
          </div>
          <div
            className="profile-review-card-verified-content"
          >
            <div className="timer">
              {/* <span>{timeLeft > 0 ? formatTime(timeLeft) : "00:00"} Min.</span> */}
            </div>
            <h3 className="heading-profile-verified">
              Profile Successfully Verified
            </h3>
            <p className="description-profile-verified">Welcome aboard!</p>
            <p className="description-profile-verified">
              Your profile is now valid for Zabali.{" "}
            </p>
            <p className="description-profile-verified">
              Explore and enjoy all our features.
            </p>

            <button
              className="profile-verified-button"
              onClick={handleHomeClick}
            >
              Go to Home page
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileVerified;
